import React from "react";
import { motion } from "framer-motion";

const WorkItems = ({ item }) => {
  return (
    <motion.div
      layout
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 10 }}
      className="work__card"
      key={item.id}
    >
      <img src={item.image} alt="img" className="work__img" />
      <h3 className="work__title">{item.title}</h3>
      <div className="work__button-group">
        <a
          href={item.live}
          target="_blank"
          rel="noopener noreferrer"
          className="work__button"
        >
          Live <i className="bx bx-right-arrow-alt work__button-icon"></i>
        </a>
        <a
          href={item.github}
          target="_blank"
          rel="noopener noreferrer"
          className="work__button"
        >
          Github <i className="bx bx-right-arrow-alt work__button-icon"></i>
        </a>
      </div>
    </motion.div>
  );
};

export default WorkItems;
